import styled from "styled-components";

type Props = {
    src: string,
    file: string,
}

const Container = styled.a`
    position: relative;

    background: black;
    font-family: "blokpol", sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 1.2rem;
    letter-spacing: 0.05em;
    font-weight: normal;
    word-spacing: 0.05em;
    padding: 0.1em .3em;
    text-align: center;

    color: white;
    text-transform: uppercase;
    text-decoration: none;
    border: none;
    cursor: pointer;

    transition: 0.3s all;
    position: relative;

    &:after {
        content: '';
        width: 100%;
        height: 1em;

        background: black;


        position: absolute;
        left: 0;
        bottom: -.5em;

        transition: .3s all;

        clip-path: polygon(0 50%,0 45%,100% 45%,100% 50%,50% 100% );
    }

    &:hover {
        color: black;
        background: white;
        &:after {
            color: black;
            background: white;
        }
    }
`;

const DownloadButton: React.FC<Props> = ({ src, file }) => {
    return <Container href={src} download={file} target='_blank'>
        Pobierz
    </Container>
}

export default DownloadButton;
